import React, { Fragment } from "react";
import { Avatar } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { FiUser } from "react-icons/fi";
import { convertTZ } from "../../config/helper";

const ChatList = ({ chat, key, response, version }) => {
	const getAvatarCache = localStorage.getItem("dataAvatar");
	const getAvatar = getAvatarCache ? JSON.parse(getAvatarCache) : {};

	return (
		<Fragment key={key}>
			<div className="chat-wrapper-separator">{chat.createdDate}</div>
			{chat.chat.map((item, idx) => {
				return (
					<div className="chat-wrapper-outer" key={idx}>
						{item.question && (
							<div className="chat-wrapper user-chat">
								<div className="chat-content-wrapper">
									<div className="chat-message">
										{item.question}
									</div>
									<div className="chat-date">
										{convertTZ(item.createdDate, "HH:mm A")}
									</div>
								</div>
							</div>
						)}
						{item.answer && (
							<div
								className={`chat-wrapper bot-chat ${
									[400, 500].includes(response.httpStatus)
										? "bot-chat-error"
										: ""
								}`}
							>
								{version === "1" && (
									<div className="chat-avatar">
										{getAvatar?.aIsrc ? (
											<Avatar src={getAvatar?.aIsrc} />
										) : (
											<Avatar icon={<FiUser />} />
										)}
									</div>
								)}
								<div className="chat-content-wrapper">
									<div className="chat-message">
										{item.answer ? (
											item.answer
												.split("\n")
												.map((i, key) => {
													return (
														<div key={key}>{i}</div>
													);
												})
										) : (
											<LoadingOutlined />
										)}
									</div>
									<div className="chat-date">
										{convertTZ(item.createdDate, "HH:mm A")}
									</div>
								</div>
							</div>
						)}
					</div>
				);
			})}
		</Fragment>
	);
};

export default ChatList;
